export function fieldHasErrors (field) {
  if (!field.required && !field.photoRequired) return false

  const v = field.required && !field.value
  const i = field.photoRequired && (!field.images || Object.keys(field.images || {}).length < 1)
  
  return [v, i].some(x => x)
}